export default {
    Form: {
        Required: 'This field is required',
        Invalid: 'Sorry but this field is invalid',
    },
};
